<template>
  <div class="content-block">
    <!-- About the Program Section -->
    <div class="about-section">
      <div class="div-outlined">
        <span class="outlined-div-heading">{{ $t('home.aboutTitle') }}</span>
        <div class="about-content">
          <p style="text-align: justify;">
            {{ $t('home.aboutDescription') }}
            {{ $t('home.trackTraceDescription') }}
          </p>
          <div class="gallery-container">
            <!-- DevExtreme Gallery for image slideshow -->
            <DxGallery
              :data-source="galleryImages"
              :loop="true"
              :show-indicator="true"
              :show-nav-buttons="true"
              width="100%"
              height="260px"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="news-notif-section-home-page">
      <!-- News Card -->
      <div class="div-outlined">
        <span class="outlined-div-heading">{{ $t('home.news') }}</span>
        <div class="list-container">
          <!-- Replace with DxList or similar component for actual data -->
          <p class="placeholder-text">{{ $t('home.noNews') }}</p>
        </div>
      </div>
      <!-- Notifications Card -->
      <div class="div-outlined">
        <span class="outlined-div-heading">{{ $t('home.notifications') }}</span>
        <div class="list-container">
           <!-- Replace with DxList or similar component for actual data -->
          <p class="placeholder-text">{{ $t('home.noNotifications') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import DevExtreme components
import { DxGallery } from 'devextreme-vue/gallery';

export default {
  name: 'DashboardHome',
  components: {
    DxGallery
  },
  data() {
    return {
      // Data source for the image gallery
      galleryImages: [
        'https://atx-transact-demo-drc-api.azurewebsites.net/content/Images/stamps/reel_5k_domestic.png',
        'https://atx-transact-demo-drc-api.azurewebsites.net/content/Images/stamps/reel_30k_domestic.png'
      ]
    };
  }
};
</script>

<style scoped>
/* Scoped styles to match the provided inspected element */
.content-wrapper {
  padding: 20px;
  background-color: #f4f4f4;
}

.news-notif-section-home-page {
  display: flex;
  gap: 20px;
  margin-top: 20px; /* Added margin to separate from the top section */
}

.div-outlined {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px;
  padding-top: 30px; /* Make space for the heading */
  position: relative;
  background-color: white;
  flex: 1;
}

.outlined-div-heading {
  position: absolute;
  top: -12px;
  left: 15px;
  background-color: white;
  padding: 0 10px;
  font-weight: 500;
  color: #555;
}

.list-container {
  height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
}

.placeholder-text {
  color: #999;
  text-align: center;
  margin-top: 20px;
}

.about-section {
  /* Removed overflow: hidden to prevent clipping the heading */
}

.about-content p {
  margin-bottom: 20px;
  line-height: 1.6;
}

.gallery-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .news-notif-section-home-page {
    flex-direction: column;
  }
}
</style>
